@if (visible) {
<div
  class="unmapped-banner"
  role="status"
  [attr.data-provider]="provider"
>
  <div class="content">
    <strong>{{ count }} unmapped event{{ count === 1 ? '' : 's' }}</strong>
    <span class="muted">
      from {{ providerLabel }}. Map the OEM fields to your Harvest Mate blocks
      so telemetry is attributed correctly.
    </span>
  </div>
  <div class="actions">
    <button class="btn-small btn-primary" type="button" (click)="onMap()">
      Map fields
    </button>
    <button
      class="btn-icon"
      type="button"
      (click)="dismiss()"
      aria-label="Dismiss"
      title="Dismiss for this session"
    >
      &times;
    </button>
  </div>
</div>
}
